@if(showLoader){
  <div class="container-fluid p-0 m-0 w-100 min-vh-100">
    <app-continuous-loading-bar dataToDisplay="{{displayDataBeingFetched()}}"></app-continuous-loading-bar>
  </div>
}
@else {
<div class="container-fluid p-0 m-0 w-100 min-vh-100">
  <div>
    <div class="sticky-top">
      <app-top-menu></app-top-menu>
      @if (!shouldHideSubMenu()) {
        <app-top-sub-menu></app-top-sub-menu>
      }
    </div>
    <div class="container-fluid">
      <div class="row">
        <div class="col-11 mx-auto">
          <!--This is to avoid reload during acquireTokenSilent() because of hidden iframe -->
          @if (!isIframe) {
            <router-outlet></router-outlet>
          }
        </div>
      </div>
    </div>
  </div>
</div>
}


